





























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import dayjs from 'dayjs'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class WidgetClock extends Vue {
  @Prop({ default: false }) dark!: boolean
  //dark = true
  time = this._time()
  second = this._seconds()
  timerInterval: any
  secondInterval: any

  //Hooks
  mounted() {
    //interval set
    this.timerInterval = setInterval(() => {
      this.time = this._time()
    }, 1000)
    this.secondInterval = setInterval(() => {
      this.second = this._seconds()
    }, 1000)

  }

  destroyed() {
    clearInterval(this.timerInterval)
    clearInterval(this.secondInterval)
  }

  _time() {
    return dayjs().minute().toString().padStart(2, '0') + ' : ' + dayjs().hour().toString().padStart(2, '0')
  }

  _seconds() {
    return dayjs().second().toString().padStart(2, '0')
  }
}

